/* @flow */
import { Map, fromJS } from 'immutable';
import { combineReducers } from 'redux-immutable';
import type { Action } from 'trustar/utils/redux-types.js';
import { calculateDayRange } from 'trustar/utils/dashboard.js';

import {
  FETCH_SUCCESS,
  SET_DATE_OPTIONS,
  FETCH_UPDATED_TIME_RANGE,
} from './action-types.js';

const defaultMeta = fromJS({
  loading: true,
  category: null,
  dateSince: null,
  dateUntil: null,
  dateRange: 'Displaying past 30 days',
  showCustom: false,
});

const meta = (state: Map<any, any> = defaultMeta, action: Action<*>) => {
  const { type, payload } = action;
  switch(type) {
  case FETCH_SUCCESS:
    return state.set('loading', false);
  case SET_DATE_OPTIONS:
    return state.merge(payload);
  case FETCH_UPDATED_TIME_RANGE:
    const { from, to } = payload;
    const dateRange = calculateDayRange(from, to);
    return defaultMeta
      .set('dateRange', dateRange);
  default: return state;
  }
};

const metrics = (state = Map(), action: Action<*>) => {
  const { type, payload } = action;
  switch (type) {
  case FETCH_SUCCESS:
    return payload;
  default: return state;
  }
};

export default combineReducers({
  meta,
  data: metrics,
});



// WEBPACK FOOTER //
// ./src/app/modules/metrics/stores.js